import React from 'react'

import Avatar from 'components/common/Avatar'
import { getTimeForChatMessages } from 'helpers/time'

import {
    TextMessageContainer,
    AvatarContainer,
    MessageContainer,
    MessageHeader,
    MessageFooter,
} from './styles'

const TextMessageView = ({ message, isContinued, isGesture }) => {
    const { senderUid, senderName, isSelf, text, time } = message
    const displayTime = getTimeForChatMessages(time)

    const showAvatar = !isContinued
    const shouldRenderHeader = !isSelf && !isContinued
    const shouldRenderFooter = isSelf

    const messageHeader = shouldRenderHeader ? (
        <MessageHeader>{`${senderName} • ${displayTime}`}</MessageHeader>
    ) : null
    const messageFooter = shouldRenderFooter ? (
        <MessageFooter>{displayTime}</MessageFooter>
    ) : null

    const avatarContainer = (
        <AvatarContainer>
            {showAvatar && <Avatar uuid={senderUid} />}
        </AvatarContainer>
    )
    const messageContainer = (
        <MessageContainer isGesture={isGesture} isSelf={isSelf}>
            {messageHeader}
            {text}
            {messageFooter}
        </MessageContainer>
    )

    return (
        <TextMessageContainer isSelf={isSelf} isContinued={isContinued}>
            {avatarContainer}
            {messageContainer}
        </TextMessageContainer>
    )
}

export default TextMessageView
